document.addEventListener('DOMContentLoaded', function () {
  const mainBox = document.querySelector('.box-message');
  const contentBox = document.querySelector('.box-message__content');
  const innerContent = document.querySelector('.box-message__inner');
  const scaleMin = 0.3;

  const screenWidthThreshold = 52 * 16 - 1;

  if (window.innerWidth > screenWidthThreshold) {
    window.addEventListener('scroll', function () {
      const scrollPosition = window.scrollY;
      const viewportHeight = window.innerHeight;
      const boundingClientRectMain = mainBox.getBoundingClientRect();
      const boundingClientRectContent = contentBox.getBoundingClientRect();
      const stickyStart =
        boundingClientRectMain.top +
        boundingClientRectMain.height / 2 -
        boundingClientRectContent.height / 2 +
        (boundingClientRectMain.height - boundingClientRectContent.height) +
        window.scrollY -
        viewportHeight / 2;

      if (scrollPosition >= stickyStart) {
        contentBox.style.scale = 1;
        innerContent.style.opacity = 1;
      } else {
        let scale = scaleMin + (scrollPosition / stickyStart) * (1 - scaleMin);
        scale = Math.max(scale, scaleMin);
        contentBox.style.scale = scale;
        innerContent.style.opacity = 0;
      }
    });
  }
});
